import { Pipe, PipeTransform, inject } from '@angular/core';
import * as handlebars from 'handlebars';
import { CurrencyPipe } from '@angular/common';

@Pipe({ name: 'handlebars', standalone: true })
export class HandlebarsPipe implements PipeTransform {
  private currencyPipe = inject(CurrencyPipe);

  constructor() {
    handlebars.registerHelper('currency', this.currencyHelper.bind(this));
  }

  transform(text: string, model: object) {
    const template = handlebars.compile(text); // this is just a temporary solution, DO NOT USE FOR EAZI STANDARD. Will be replaced by rendering in Backend in the future
    return template(model);
  }

  currencyHelper(value: string, currencyCode: string, display: string, digitsInfo: string, locale: string) {
    return this.currencyPipe.transform(value, currencyCode, display, digitsInfo, locale);
  }
}
